import { useState } from 'react';
import {
  CasReactHookFormDialog,
  CasRHFDatePicker,
  CasRHFNumberField,
  CasRHFSelect,
} from 'src/compass/shared/components';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';
import { DateFormat, formatDate, getDateInMoment } from 'src/compass/shared/util/casMoment';
import { FormMethodType } from 'src/compass/shared/components/CasForm/CasReactHookForm';

import { NoticeReceivedSchema } from '../schema/NoticeReceivedSchema';
import { StatusButtonConfig } from './ClaimTrackingStatusActions';

type NoticeReceivedDialogProps = StatusButtonConfig & {
  onClose: VoidFunction;
  endorsementId: number;
  onUpdated: Function;
};

const HAS_CLAIM_OPTIONS = StringsToOptions(['', 'CLAIM', 'No Claim']);

export default function NoticeReceivedDialog({
  url,
  endorsementId,
  onClose,
  onUpdated,
}: NoticeReceivedDialogProps) {
  const minDate = formatDate(getDateInMoment().add(1, 'days'), DateFormat.YMD);
  const maxDate = formatDate(getDateInMoment().add(60, 'days'), DateFormat.YMD);
  const [formMethods, setFormMethods] = useState<FormMethodType | null>(null);
  const [hasClaim, setHasClaim] = useState(null);

  const { mutate } = useUpdateMutation({
    url,
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onUpdated();
      onClose();
    },
  });

  const onSubmit = (payload: any) => mutate({ endorsementId, ...payload });

  return (
    <CasReactHookFormDialog
      open
      onSubmit={onSubmit}
      onClose={onClose}
      title="Notice Received"
      submitButtonLabel="Save"
      schema={NoticeReceivedSchema}
      setFormMethods={setFormMethods}
    >
      <CasRHFSelect
        name="hasClaim"
        label="Has Claim"
        options={HAS_CLAIM_OPTIONS}
        onChange={(_, value) => {
          setHasClaim(value);
          if (value === 'No Claim') {
            formMethods?.setValue('claimDueByDate', null);
            formMethods?.setValue('claimNumber', null);
          }
        }}
      />
      {hasClaim === 'CLAIM' && (
        <>
          <CasRHFDatePicker
            name="claimDueByDate"
            label="Signed Claim Due By"
            minDate={minDate}
            maxDate={maxDate}
          />
          <CasRHFNumberField name="claimNumber" label="Claim#" />
        </>
      )}
    </CasReactHookFormDialog>
  );
}
